var $name="isDesktopBreakpoint",$path="app/utilities/isDesktopBreakpoint.js",$this={$name,$path,};import { breakpoints } from 'configs';

const isDesktopBreakpoint = () => window.innerWidth >= breakpoints.xl.min;

export default isDesktopBreakpoint;
